(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mom-ant-cursor"] && !Shopify.designMode) return;
  try {
    (() => {
  const desktop = matchMedia('(hover: hover) and (pointer: fine)');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const root = document.documentElement;
  let timers = [];
  const reset = () => {
    timers.forEach(clearTimeout);
    timers = [];
    root.classList.remove('mom-ant-step-1', 'mom-ant-step-2');
  };
  document.addEventListener('pointerdown', event => {
    if (!desktop.matches || event.pointerType !== 'mouse' || event.button !== 0) return;
    reset();
    if (reducedMotion.matches) return;
    root.classList.add('mom-ant-step-1');
    timers.push(setTimeout(() => {
      root.classList.remove('mom-ant-step-1');
      root.classList.add('mom-ant-step-2');
    }, 240));
    timers.push(setTimeout(reset, 480));
  }, { passive: true });
  window.addEventListener('blur', reset);
  desktop.addEventListener('change', reset);
})();
  } catch(e) { console.error(e); }
})();

})();
